// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamPowerIndicator__root--BB_B4 {
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    position: relative;
}

    @media screen and (max-width: 1023px) {.TeamPowerIndicator__root--BB_B4 {
        padding: 0 24px
}
    }

.TeamPowerIndicator__title--J__ow {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.6px;
    text-align: center;
    text-transform: uppercase;
    color: var(--secondary-color);
}

.TeamPowerIndicator__indicator--s45kf {
    width: 100%;
    border-radius: 4px;
    background-color: var(--dark-tertiary-new-color);
    overflow: hidden;
    padding: 1px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.TeamPowerIndicator__activeBar--RG6Tv {
    transition: width 0.25s ease-in-out;
    background-color: var(--secondary-color);
    border-radius: 2px;
    height: 4px;
    position: relative;
    z-index: 2;
}

.TeamPowerIndicator__description--FHBUR {
    background: var(--premium-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    position: absolute;
    bottom: -8px;
    left: 0;
    text-align: center;
    width: 100%;
    transform: scale(0.8);
    animation: none;
}

.TeamPowerIndicator__description--FHBUR.TeamPowerIndicator__visible--pzF4P {
        animation: TeamPowerIndicator__sprite--jTBJP 3s;
        animation-iteration-count: 1;
    }

@keyframes TeamPowerIndicator__sprite--jTBJP {
    0% {
        opacity: 0;
        transform: scale(0.8);
    }
    15% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 1;
        transform: scale(0.9);
    }
    80% {
        opacity: 0;
        transform: scale(0.8);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TeamPowerIndicator/TeamPowerIndicator.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AAKtB;;IAHI,uCAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gDAAgD;IAChD,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;IACV,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,eAAe;AAMnB;;AAJI;QACI,+CAAoB;QACpB,4BAA4B;IAChC;;AAGJ;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ","sourcesContent":[".root {\n    width: 100%;\n    max-width: 640px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n    position: relative;\n\n    @media (--mobile) {\n        padding: 0 24px;\n    }\n}\n\n.title {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    letter-spacing: 0.6px;\n    text-align: center;\n    text-transform: uppercase;\n    color: var(--secondary-color);\n}\n\n.indicator {\n    width: 100%;\n    border-radius: 4px;\n    background-color: var(--dark-tertiary-new-color);\n    overflow: hidden;\n    padding: 1px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.activeBar {\n    transition: width 0.25s ease-in-out;\n    background-color: var(--secondary-color);\n    border-radius: 2px;\n    height: 4px;\n    position: relative;\n    z-index: 2;\n}\n\n.description {\n    background: var(--premium-gradient);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 20px;\n    letter-spacing: 0.9px;\n    text-transform: uppercase;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    position: absolute;\n    bottom: -8px;\n    left: 0;\n    text-align: center;\n    width: 100%;\n    transform: scale(0.8);\n    animation: none;\n\n    &.visible {\n        animation: sprite 3s;\n        animation-iteration-count: 1;\n    }\n}\n\n@keyframes sprite {\n    0% {\n        opacity: 0;\n        transform: scale(0.8);\n    }\n    15% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    50% {\n        opacity: 1;\n        transform: scale(0.9);\n    }\n    80% {\n        opacity: 0;\n        transform: scale(0.8);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TeamPowerIndicator__root--BB_B4`,
	"title": `TeamPowerIndicator__title--J__ow`,
	"indicator": `TeamPowerIndicator__indicator--s45kf`,
	"activeBar": `TeamPowerIndicator__activeBar--RG6Tv`,
	"description": `TeamPowerIndicator__description--FHBUR`,
	"visible": `TeamPowerIndicator__visible--pzF4P`,
	"sprite": `TeamPowerIndicator__sprite--jTBJP`
};
export default ___CSS_LOADER_EXPORT___;
